import React from "react";
import { cn } from "../../../../../lib/utils";

interface NarrowHeaderProps {
  children?: React.ReactNode;
  className?: string;
}

/**
 * Cabeçalho que pode quebrar em duas linhas.
 *
 * O StyledTh de components/ui/table.tsx fixa `white-space: nowrap`, o que faz a coluna
 * ficar tão larga quanto o título e estica a tabela inteira. Como aquele componente é
 * compartilhado por todas as tabelas do app, a quebra é sobrescrita aqui, localmente:
 * `whitespace-normal` vale para o conteúdo desta div e vence o nowrap herdado do th.
 *
 * `leading-tight` mantém duas linhas dentro dos 40px de altura fixa do th.
 *
 * `mx-auto` é necessário porque o th tem `text-left`: sem ele, a div de largura fixa
 * fica encostada à esquerda em vez de centralizada na coluna.
 */
export const NarrowHeader: React.FC<NarrowHeaderProps> = ({
  children,
  className,
}) => (
  <div
    className={cn(
      "mx-auto flex items-center justify-center text-center whitespace-normal leading-tight",
      className
    )}
  >
    {children}
  </div>
);

interface DisabledCellProps extends React.HTMLAttributes<HTMLDivElement> {
  hasDeposit?: boolean;
  children?: React.ReactNode;
}

export const DisabledCell: React.FC<DisabledCellProps> = ({ 
  hasDeposit = false, 
  children, 
  className,
  ...props 
}) => {
  return (
    <div 
      className={cn(
        "w-full h-full flex items-center justify-start text-[#74788D] cursor-not-allowed",
        hasDeposit ? "bg-[#e9e9efa6]" : "bg-[#FEDCDB]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

interface DepositContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

export const DepositContainer: React.FC<DepositContainerProps> = ({ 
  children, 
  className,
  ...props 
}) => {
  return (
    <div 
      className={cn(
        "w-[900px] overflow-auto max-h-[600px]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};